import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
import { Section } from './Shared';
export const FAQ = () => {
  const faqs = [{
    q: '¿Sirve si recién empiezo como terapeuta?',
    a: 'Especialmente si recién empezás. El sistema te da la estructura profesional desde el primer paciente. No tenés que improvisar ni esperar a tener años de experiencia para trabajar con orden.'
  }, {
    q: '¿Cómo recibo el material?',
    a: '100% digital. Al confirmar el pago recibís el acceso a los 3 PDFs en menos de 5 minutos. Descargás, imprimís y empezás a usar ese mismo día.'
  }, {
    q: '¿Necesito imprimirlo todo?',
    a: 'El Tomo Principal podés leerlo en pantalla. Las planillas están diseñadas para imprimir y rellenar a mano. Te recomendamos imprimir las planillas de sesión en cantidad para tenerlas siempre listas.'
  }, {
    q: '¿Qué lo diferencia de una ficha que puedo bajar gratis de internet?',
    a: 'Las fichas que encontrás online son genéricas. REFLEXO-PRO fue diseñado específicamente para la reflexología, con las zonas reflejas reales, los protocolos clínicos correctos, el lenguaje técnico adecuado y la lógica de un sistema completo que funciona junto. No es una ficha. Es un sistema.'
  }, {
    q: '¿Tiene garantía real?',
    a: 'Sí. 7 días, sin preguntas, devolución del 100%. Escribís a soportelumenakasha@gmail.com y listo.'
  }, {
    q: '¿Puedo compartirlo con otros terapeutas?',
    a: 'No. La licencia es personal e intransferible. Cada terapeuta debe adquirir su propio kit. La redistribución no autorizada viola los derechos de autor.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <Section className="max-w-3xl" data-id="element-60">
      <div className="text-center mb-12" data-id="element-61">
        <h2 className="md:text-4xl font-serif font-bold mb-4 flex items-center justify-center text-[22px]" data-id="element-62">
          <span className="mr-3" data-id="element-63">❓</span> LO QUE MÁS NOS PREGUNTAN
        </h2>
      </div>

      <div className="space-y-4" data-id="element-64">
        {faqs.map((faq, i) => <div key={i} className="glass-panel rounded-2xl overflow-hidden border-brand-pink/30 bg-white/60" data-id="element-65">
            <button onClick={() => setOpenIndex(openIndex === i ? null : i)} className="w-full px-6 py-5 text-left flex justify-between items-center focus:outline-none hover:bg-brand-surfaceLight/30 transition-colors" data-id="element-66">
              <span className="font-medium pr-8 text-brand-text text-[14px]" data-id="element-67">
                {faq.q}
              </span>
              <ChevronDown className={`w-5 h-5 text-brand-rose transition-transform duration-300 shrink-0 ${openIndex === i ? 'rotate-180' : ''}`} data-id="element-68" />
            </button>
            <AnimatePresence data-id="element-69">
              {openIndex === i && <motion.div initial={{
            height: 0,
            opacity: 0
          }} animate={{
            height: 'auto',
            opacity: 1
          }} exit={{
            height: 0,
            opacity: 0
          }} transition={{
            duration: 0.3
          }} data-id="element-70">
                  <div className="px-6 pb-5 text-brand-text/70 border-t border-brand-pink/20 pt-4 bg-white/40 text-[12px]" data-id="element-71">
                    {faq.a}
                  </div>
                </motion.div>}
            </AnimatePresence>
          </div>)}
      </div>
    </Section>;
};